
































import {Component, Prop, Vue} from "vue-property-decorator";
import VueError from "@/components/VueError.vue";
import Success from "@/components/Success.vue";
import {IoTCoreCert} from "@/types/core";
import {CoreClient, curCoreClient} from "@/services/CoreClient";
import ConfirmDialog from "@/components/shared/ConfirmDialog.vue";

@Component({
  components: {
    VueError,
    Success,
    ConfirmDialog
  },
})
export default class MqttCertRow extends Vue {
  @Prop({ default: '',  type: String}) apiKeyId!: string;
  @Prop({ default: {},  type: Object}) cert!: IoTCoreCert;
  @Prop({ default: 0,  type: Number}) index!: number;

  private coreClient:CoreClient = curCoreClient;
  private error:string = '';

  async showConfirmCertDeactivation() {
    (this.$refs.confirmCertDeactivation as ConfirmDialog).show(this.deactivate);
  }

  async showConfirmCertDeletion() {
    (this.$refs.confirmCertDeletion as ConfirmDialog).show(this.deleteCert);
  }

  async deactivate() {
    this.error = '';
    const reply = await this.coreClient.deactivateMQTTCert(this.apiKeyId, this.cert);
    if ( reply.errorMsg ) {
      this.error = reply.errorMsg;
      return;
    }
    this.cert.active = false;
  }

  async activate() {
    this.error = '';
    const reply = await this.coreClient.activateMQTTCert(this.apiKeyId, this.cert);
    if ( reply.errorMsg ) {
      this.error = reply.errorMsg;
      return;
    }
    this.cert.active = true;
  }

  async deleteCert() {
    this.error = '';
    const reply = await this.coreClient.deleteMQTTCert(this.apiKeyId, this.cert);
    if ( reply.errorMsg ) {
      this.error = reply.errorMsg;
      return;
    }
    this.$emit('delete', this.cert.certId);
  }
}
